import { render, staticRenderFns } from "./LiveCard.vue?vue&type=template&id=152f465b&scoped=true"
import script from "./LiveCard.vue?vue&type=script&lang=js"
export * from "./LiveCard.vue?vue&type=script&lang=js"
import style0 from "./LiveCard.vue?vue&type=style&index=0&id=152f465b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f465b",
  null
  
)

export default component.exports